import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import TextEllipsis from '../../../../common/textEllipsis'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { EMPTY_VALUE, Z_INDEX } from '../../../../utils/common'
import { TitleComponent } from '../../../common/html/TitleComponent'
import { TranslateCompanies } from '../../../common/text/TranslateCustom'
import {
  changeActiveVSIC,
  selectActiveVSIC,
  selectIdKeyVSIC,
  selectTotalCompany,
  selectVSIC,
} from '../store/slice'

export const Header = ({ setCallApi }) => {
  const dispatch = useDispatch()

  const vsicActive = useSelector(selectActiveVSIC)
  const dataVSIC = useSelector(selectVSIC)
  const totalCompany = useSelector(selectTotalCompany)
  const idKeyVSIC = useSelector(selectIdKeyVSIC)
  const locale = useSelector((state) => state.i18n.locale)

  //Actions
  const handelSelectVSIC = (value) => {
    dispatch(changeActiveVSIC(value))
    setCallApi((prev) => !prev)
  }

  useEffect(() => {
    const vsic = dataVSIC.find((item) => item?.id === idKeyVSIC)
    dispatch(changeActiveVSIC(vsic))
  }, [])

  return (
    <div className="dFlex justifyContentBetween gap5">
      <TitleComponent
        title="dashboard.creditRisk.title"
        style={{ whiteSpace: 'nowrap' }}
      />
      <div>
        <div className="dFlex justifyContentBetween alignItemsCenter">
          <Element
            style={{
              lineHeight: '16px',
              fontWeight: 600,
            }}
          >
            <Translate value="dashboard.creditRisk.industry" />:
          </Element>

          <div>
            <SelectCustom
              renderActiveItem={() => (
                <ActiveItem item={vsicActive} key={locale} />
              )}
              data={dataVSIC}
              chooseItem={handelSelectVSIC}
              style={{
                borderColor: 'transparent',
                paddingLeft: 4,
                paddingRight: 0,
              }}
              styleDropdown={{
                maxWidth: 400,
                maxHeight: 600,
              }}
              renderDropdownItem={(item, onClickItem) => (
                <ItemVSIC
                  item={item}
                  onClick={() => onClickItem(item)}
                  isActive={vsicActive?.value === item?.value}
                />
              )}
              iconWhenShowDropList="icon-arrow-top-bold"
              iconWhenHiddenDropList="icon-arrow-bottom-bold"
              iconNoPosition
            />
          </div>
        </div>
        <Element>
          <TranslateCompanies count={totalCompany} />
        </Element>
      </div>
    </div>
  )
}

const styles = {
  ACTIVE: {
    color: '#0553A5',
    backgroundColor: '#E5F2FF',
  },
  INACTIVE: {
    color: '#191D25',
    backgroundColor: '',
  },
}

export const ItemVSIC = ({ item, onClick, isActive }) => {
  const [style, setStyle] = useState(
    item.isActive ? styles.ACTIVE : styles.INACTIVE,
  )

  const onMouseEnter = () => {
    setStyle(styles.ACTIVE)
  }

  const onMouseLeave = () => {
    setStyle(styles.INACTIVE)
  }
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className="cursorPointer"
      style={{
        color: isActive ? '#0553A5' : style.color,
        backgroundColor: style.backgroundColor,
        fontWeight: isActive ? 500 : 400,
      }}
      onClick={onClick}
    >
      <Element style={{ padding: '4px 12px', maxWidth: 400 }}>
        <TextEllipsis
          isI18n={false}
          text={`${item?.code} - ${item?.label}` || EMPTY_VALUE}
          zIndexTooltip={Z_INDEX.MODAL + 1}
        />
      </Element>
    </div>
  )
}

export const ActiveItem = ({ item }) => {
  return (
    <>
      <Element
        className="fw600"
        style={{
          lineHeight: '16px',
          maxHeight: '50ch',
        }}
      >
        <TextEllipsisStaticLine
          text={`${item?.code} - ${item?.label}`}
          lineClamp={1}
          isI18n={false}
        />
      </Element>
    </>
  )
}
